import React, { useEffect, useMemo } from "react";
import { Cookie } from "../angular-app-handlers";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import NotifyPopup, {
  NotifyPopupConfigParams,
} from "../common_components/common_widgets/notify-popup";
import ConfirmationPopup, {
  ConfirmationPopupConfigParams,
} from "../common_components/common_widgets/confirmation-popup";
import {
  TOGGLE_CPT_LICENSING_POPUP,
  TOGGLE_INACTIVE_SESSION_WARNING_POPUP,
  TOGGLE_REFRESH_TOKEN_FAILED_POPUP,
  TOGGLE_SECURITY_NOTICE_POPUP,
} from "./reducers/appReducer";
import { isEqual } from "lodash";
import Cookies from "js-cookie";
import {
  getUnsentNotifications,
  updateNotificationsList,
  updateReadStatusOfNotification,
} from "../common_components/common_widgets/notification-and-system-messages-module/notification-component";
import { getSystemMessage } from "../common_components/common_widgets/notification-and-system-messages-module/system-messages-component";
import { FG_EXTERNAL_USER_TASK_EDITING, hasAnyFeatureGroupAccess } from "../common_components/user-permissions-helper";
import { mdaeApiOktaAccessTokenKey } from "../call-web-api";

export const popupMessageLeadTimeMinutes = 15;
export const readNotificationsStorageKey = "user-read-notifications";
export const unsentNotificationsStorageKey = "user-unsent-notifications";
let isActive = false;
let lastActivityTimestamp = new Date().getTime();
let maxIdleTimeMiliSeconds = 1800000;
let idleTimePopupMiliSeconds = 300000;
let refreshTokenInterval = 2700;
let refreshTokenFailedWarningDialogTime = 720;
let pingCooldown = 0;
let refreshTokenFailed;
let isRefreshTokenFailureCountdownDialogOpen;
let isInactiveSessionWarningPopupOpen;
const clientIdCookie = "MDAuditEnterprise_ClientIdCookie";
const tzCookieName = "MDauditEnterprise_TimezoneCookie";
const cptCookieName = "MDAuditEnterprise_CPTCookie";

const pingCooldownMax = 5;
const SECURITY_NOTICE_REQUIRED_COOKIE = "SECURITY_NOTICE_REQUIRED";
const SECURITY_NOTICE_COOKIE = "SECURITY_NOTICE_SEEN";
export const getHighestZIndex = function() {
  var highestZIndex = 100;
  $("div:visible").each(function() {
    let currentZIndex = parseInt($(this).css("z-index"));
    if (!isNaN(currentZIndex) && currentZIndex > highestZIndex)
      highestZIndex = currentZIndex;
  });
  return highestZIndex + "";
};
const setLastActivityTime = function() {
  if (Cookie.get("isCountdownDialogOpen") != "true") {
    lastActivityTimestamp = new Date().getTime();
    Cookie.set("lastActivityTimestamp", lastActivityTimestamp);
  }
};

const refreshTokenFailedWarningHtml = () => {
  return (
    <div>
      <p className="mdae-standalone-label">
        There has been an unexpected error occur in our system which requires
        that you sign back in.
      </p>
      <p className="mdae-standalone-label" style={{ height: "50px" }}>
        Please remember to save your work first. You will be automatically
        logged out after{" "}
        <b>
          <span id="refreshTokenFailureLogoutTimeRemaining"></span> seconds
        </b>
        .
      </p>
    </div>
  );
};

const inactiveSessionWarningPopupHtml = () => {
  return (
    <div>
      <p className="mdae-standalone-label">
        Your session is about to expire in
        <b>
          &nbsp;<span id="idleTimeRemaining">300</span> seconds
        </b>
        .
      </p>
      <p className="mdae-standalone-label" style={{ height: "50px" }}>
        Would you like to continue working?
      </p>
    </div>
  );
};

const securityNoticeWarningPopupHtml = () => {
  return (
    <div>
      This application is intended for authorized use and restricted to those
      individuals with specific permissions. Unauthorized access to this
      application is prohibited.
      <br />
      Monitoring may be conducted for this application as required to ensure its
      stability, availability and security and to protect against improper or
      unauthorized use or access.
      <br />
      Clicking the OK button below constitutes consent to monitoring and
      acknowledgement of this information.
    </div>
  );
};

const sessionConfigs = {
  refreshSession: () => {
    let request = $.ajax({
      url:
        "/home/authorizedrefresh?random=" +
        Math.random()
          .toString(36)
          .substring(7),
      method: "GET",
    });
    request.done(function() {
      setLastActivityTime();
    });
  },
  logUserLogout: (logoutType) => {
    var phiData = { accessType: logoutType };
    var url = "/Api/PhiLogger/LogPhiAccess";
    sessionConfigs.logLogoutActivity(url, phiData);
  },
  logLogoutActivity: (url, phiData) => {
    $.ajax(url, {
      type: "POST",
      data: JSON.stringify(phiData),
      dataType: "json",
      contentType: "application/json",
      async: false,
      success: function() {},
      error: function(xhr, status, err) {
        console.log(err);
      },
    });
  },
  logoutAll: () => {
    var mdaiBaseUrl = localStorage.getItem("MdaiBaseUrl");
    if (mdaiBaseUrl) {
      localStorage.removeItem("MdaiBaseUrl");
      $.ajax(mdaiBaseUrl + "/callosum/v1/session/logout", {
        type: "POST",
        headers: {
          "X-Requested-By": "ThoughtSpot",
        },
        xhrFields: {
          withCredentials: true,
        },
        success: function(data) {
          console.log("MDAI logout successful");
        },
        error: function() {
          console.log("MDAI logout failed");
        },
      });
    }
    Cookie.erase(clientIdCookie);
    Cookie.erase(SECURITY_NOTICE_COOKIE);
    Cookies.remove(tzCookieName);
    sessionConfigs.logUserLogout("UserLogout");
    setTimeout(function() {
      window.location.href = "/Account/Logout";
    }, 1000);
  },
};

const ApplicationEventHandler: React.FC<any> = (props) => {
  const dispatch = useDispatch();

  isRefreshTokenFailureCountdownDialogOpen = useSelector(
    (state) => state["appReducer"].refreshTokenPopupConfig?.visible,
    isEqual
  );

  isInactiveSessionWarningPopupOpen = useSelector(
    (state) => state["appReducer"].inactiveSessionWarningPopupConfig?.visible,
    isEqual
  );

  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const isExternalUser = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser]
  );

  const securityWarningConfigs = {
    toggleSecurityWarningWindow: () => {
      const securityNoticeSeen = Cookie.get(SECURITY_NOTICE_COOKIE);
      const showSecurityNotice = Cookie.get(SECURITY_NOTICE_REQUIRED_COOKIE);
      if (
        showSecurityNotice === "True" &&
        securityNoticeSeen !== "True" &&
        window.location.pathname != "/Admin/TermsOfUseUserAgreement"
      ) {
        dispatch({
          type: TOGGLE_SECURITY_NOTICE_POPUP,
          data: {
            visible: true,
            title: "Notice",
            isPopupShowCloseButton: true,
            isHideNotifyTypeIcon: true,
            closeButtonText: "OK",
            notifyOkButtonHandler: () => {
              Cookie.set(SECURITY_NOTICE_COOKIE, "True");
            },
            contentHtml: securityNoticeWarningPopupHtml,
          } as NotifyPopupConfigParams,
        });
      }
    },
    cptLicensingPopupHtml: () => {
      return (
        <div className="cpt-licensing-message mdae-standalone-label">
          CPT® only © 2016 American Medical Association. All rights reserved.
          <br />
          <br />
          Fee schedules, relative value units, conversion factors and/or related
          components are not assigned by the AMA, are not part of CPT, and the
          AMA is not recommending their use. The AMA does not directly or
          indirectly practice medicine or dispense medical services. The AMA
          assumes no liability for data contained or not contained herein.
          <br />
          <br />
          CPT® is a registered trademark of the American Medical Association.
          <br />
          <br />
          The responsibility for the content of any "National Correct Coding
          Policy" included in this product is with the Centers for Medicare and
          Medicaid Services and no endorsement by the AMA is intended or should
          be implied. The AMA disclaims responsibility for any consequences or
          liability attributable to or related to any use, nonuse or
          interpretation of information contained in this product.
        </div>
      );
    },
    toggleCptLicensingWarningWindow: () => {
      dispatch({
        type: TOGGLE_SECURITY_NOTICE_POPUP,
        data: {
          visible: true,
          title: "CPT Licensing",
          isHideNotifyTypeIcon: true,
          closeButtonText: "OK",
          width: 600,
          height: "auto",
          contentHtml: securityWarningConfigs.cptLicensingPopupHtml,
        } as NotifyPopupConfigParams,
      });
    },
  };

  const inactiveSessionConfig = {
    openWarningWindow: () => {
      Cookie.set("isCountdownDialogOpen", "true");
      let setIntervalId = inactiveSessionConfig.setCountdownTimerForIdlePopup();
      dispatch({
        type: TOGGLE_INACTIVE_SESSION_WARNING_POPUP,
        data: {
          contentHtml: inactiveSessionWarningPopupHtml,
          title: "Are you still there?",
          visible: true,
          declineShown: true,
          declineLabel: "No just logout",
          confirmShown: true,
          confirmLabel: "Yes continue",
          width: 450,
          height: 210,
          onConfirm: () => {
            inactiveSessionConfig.closeWarningWindow();
            setLastActivityTime();
            sessionConfigs.refreshSession();
            clearInterval(setIntervalId);
          },
          onDecline: () => {
            inactiveSessionConfig.closeWarningWindow();
            sessionConfigs.logoutAll();
          },
        } as ConfirmationPopupConfigParams,
      });
    },
    closeWarningWindow: () => {
      Cookie.set("isCountdownDialogOpen", "false");
      dispatch({
        type: TOGGLE_INACTIVE_SESSION_WARNING_POPUP,
        data: {
          visible: false,
        },
      });
    },
    setCountdownTimerForIdlePopup: () => {
      var setIntervalId = setInterval(function() {
        if (Cookie.get("isCountdownDialogOpen") != "true") {
          inactiveSessionConfig.closeWarningWindow();
          setLastActivityTime();
          clearSelf();
        } else {
          let currentTimestamp = new Date().getTime();
          let inactiveTimeInSeconds = parseInt(
            (currentTimestamp - parseInt(Cookie.get("lastActivityTimestamp"))) /
              1000 +
              ""
          );
          let idleTimeReaminingInSecond =
            maxIdleTimeMiliSeconds / 1000 - inactiveTimeInSeconds;
          $("#idleTimeRemaining").html(idleTimeReaminingInSecond + "");
          if (idleTimeReaminingInSecond > 0) {
            $("#idleTimeRemaining").html(idleTimeReaminingInSecond + "");
          } else {
            clearSelf();
            sessionConfigs.logoutAll();
          }
        }
      }, 1000);
      var clearSelf = function() {
        clearInterval(setIntervalId);
      };
      return setIntervalId;
    },
  };

  const refreshTokenConfig = {
    refreshToken: () => {
      if (Cookie.get("cognitoTokenRefreshInitiated") != "true") {
        Cookie.set("cognitoTokenRefreshInitiated", "true");
        var request = $.ajax({
          url:
            "/Account/RefreshToken?random=" +
            Math.random()
              .toString(36)
              .substring(7),
          method: "GET",
          timeout: 600000, // Request timeout 10 Min.
        });
        request.done((msg) => {
          Cookie.set("cognitoTokenRefreshInitiated", "false");
          if (
            msg == null ||
            (msg != null && msg.authenticationResult == null)
          ) {
            console.log("Token Refresh FAILED." + new Date().getTime());
            refreshTokenFailed = true;
            Cookie.set("refreshToeknFailedTimestamp", new Date().getTime());
            refreshTokenConfig.openRefreshTokenFailureWarningWindow();
          } else {
            // Reset
            var id_token = msg.authenticationResult.idToken;
            //loadFrames(id_token);
            //window.idleTimeRemaining = window.maxIdleTimeSeconds;
            //Cookie.set("countdown", window.idleTimeRemaining);
            let tokenIssueTimestamp = new Date().getTime();
            Cookie.set("tokenIssueTimestamp", tokenIssueTimestamp);
            console.log("Token is refreshed at " + tokenIssueTimestamp);
          }
        });
        request.fail(function(jqXHR, textStatus) {
          console.log("Token Refresh FAILED." + new Date().getTime());
          Cookie.set("cognitoTokenRefreshInitiated", "false");
          Cookie.set("refreshToeknFailedTimestamp", new Date().getTime());
          refreshTokenConfig.openRefreshTokenFailureWarningWindow();
        });
      }
    },
    setCountdownTimerForRefreshTokenFailedPopup: () => {
      if (Cookie.get("refreshTokenFailed") == "true") {
        var setIntervalId = setInterval(function() {
          /* CLOSE THE REFRESH TOKEN FAILED WARNING POPUP IS CLOSED IN ANY OTHER TAB THEN CLOSE IT */
          if (Cookie.get("isRefreshTokenFailedPopupClosedByUser") == "true") {
            refreshTokenConfig.closeRefreshTokenFailureWarningWindow();
          }
          let currentTimestamp = new Date().getTime();
          let timeElapsedAfterRefreshTokenFail =
            currentTimestamp -
            parseInt(Cookie.get("refreshToeknFailedTimestamp"));
          let timeRemainingBeforeLogout =
            refreshTokenFailedWarningDialogTime -
            parseInt(timeElapsedAfterRefreshTokenFail / 1000 + "");
          if (timeRemainingBeforeLogout > 0) {
            $("#refreshTokenFailureLogoutTimeRemaining").html(
              timeRemainingBeforeLogout + ""
            );
          } else {
            sessionConfigs.logoutAll();
          }
        }, 1000);
      }
    },
    openRefreshTokenFailureWarningWindow: () => {
      dispatch({
        type: TOGGLE_REFRESH_TOKEN_FAILED_POPUP,
        data: {
          contentHtml: refreshTokenFailedWarningHtml,
          isPopupShowCloseButton: true,
          isHideNotifyTypeIcon: true,
          title: "Are you still there?",
          closeButtonText: "Close",
          visible: true,
          height: "auto",
          width: 500,
        } as NotifyPopupConfigParams,
      });
    },
    closeRefreshTokenFailureWarningWindow: () => {
      Cookie.set("isRefreshTokenFailedPopupClosedByUser", "true");
      if (isRefreshTokenFailureCountdownDialogOpen) {
        dispatch({
          type: TOGGLE_REFRESH_TOKEN_FAILED_POPUP,
          data: {
            visible: false,
          } as NotifyPopupConfigParams,
        });
      }
    },
  };

  const pingServer = function() {
    /* IF USER IS ACTIVE ON THIS TAB AND REFRESH TOKEN IS FAILED ON OTHER TAB THEN SHOW THE WARNING POPUP TO THE USER */
    if (
      Cookie.get("refreshTokenFailed") == "true" &&
      Cookie.get("isRefreshTokenFailedPopupClosedByUser") != "true" &&
      !isRefreshTokenFailureCountdownDialogOpen
    ) {
      refreshTokenConfig.openRefreshTokenFailureWarningWindow();
    }

    if (pingCooldown === pingCooldownMax) {
      pingCooldown = 0;
      const currrentLocation = window.location.href.toLowerCase();
      if (
        currrentLocation.indexOf("/user/passwordresetfailure") !== -1 ||
        currrentLocation.indexOf("/user/passwordresetsuccess") !== -1 ||
        currrentLocation.indexOf("/user/getpasswordresetemail") !== -1 ||
        currrentLocation.indexOf("/user/resetpassword") !== -1 ||
        currrentLocation.indexOf("/user/register") !== -1
      ) {
        return false;
      }

      getUnsentNotifications(dispatch);
      getSystemMessage(dispatch);
      for (let i = 0; i < (window as any).refreshHooks?.length; i++) {
        (window as any).refreshHooks[i]();
      }
    }
  };

  const checkClientTimeZone = function() {
    var dt = new Date();
    var tz = -dt.getTimezoneOffset();
    var nextYear = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );
    Cookies.set(tzCookieName, tz.toString(), { expires: nextYear });
  };

  const checkClientIdCookie = function() {
    const currentLocation = window.location.href.toLowerCase();
    if (
      currentLocation.indexOf("/user/resetpassword") !== -1 ||
      currentLocation.indexOf("/user/register") !== -1 ||
      currentLocation.indexOf("/user/getpasswordresetemail") !== -1 ||
      currentLocation.indexOf("/user/passwordresetsuccess") !== -1 ||
      currentLocation.indexOf("/user/passwordresetfailure") !== -1
    ) {
      return false;
    }

    var enterpriseClientId = Cookie.get(clientIdCookie);
    if ((window as any)._c == null) {
      (window as any)._c = JSON.parse(
        $.ajax({ type: "GET", url: "/Api/Utility/GetClientId", async: false })
          .responseText
      ).clientId;
    }
    if ((window as any)._c && enterpriseClientId) {
      if (enterpriseClientId != (window as any)._c) {
        console.log("ClientId mismatch!");
        window.location.href = "/home/invalidstate";
      }
    }
  };

  const windowEventHandlers = {
    mouseUpHandler: () => {
      isActive = true;
      setLastActivityTime();
      pingServer();
      checkClientIdCookie();
    },
    keyPressHandler: () => {
      isActive = true;
      setLastActivityTime();
      pingServer();
    },
    blurHandler: () => {
      isActive = false;
    },
    mouseMoveHandler: () => {
      setLastActivityTime();
      pingServer();
      isActive = true;
    },
    focusHandler: () => {
      isActive = true;
      setLastActivityTime();
      pingServer();
      checkClientIdCookie();
    },
    storageHandler: (event) => {
      if (
        event &&
        event.key == unsentNotificationsStorageKey &&
        localStorage.getItem(unsentNotificationsStorageKey) != null
      ) {
        var unsentNotifications = JSON.parse(
          localStorage.getItem(unsentNotificationsStorageKey)
        );
        if (unsentNotifications && unsentNotifications.length) {
          updateNotificationsList(dispatch, unsentNotifications);
        }
      }
      if (
        event &&
        event.key == readNotificationsStorageKey &&
        localStorage.getItem(readNotificationsStorageKey) != null
      ) {
        var readNotifications = JSON.parse(
          localStorage.getItem(readNotificationsStorageKey)
        );
        if (readNotifications && readNotifications.length) {
          for (let i = 0; i < readNotifications.length; i++)
            updateReadStatusOfNotification(dispatch, readNotifications[i]);
        }
      }

      setTimeout(function() {
        if (
          event.key == unsentNotificationsStorageKey ||
          event.key == readNotificationsStorageKey
        ) {
          localStorage.removeItem(unsentNotificationsStorageKey);
          localStorage.removeItem(readNotificationsStorageKey);
        }
      }, 500);
    },
  };

  const loadConfigValues = () => {
    $.ajax({
      url: "/api/utility/getaccesstoken",
      type: "GET",
      success: function(data) {
          (window as any).token = data;
          sessionStorage.setItem(mdaeApiOktaAccessTokenKey, data);
      },
    });

    $.ajax({
      url: "/api/client/getInactiveSessionTimeout",
      type: "GET",
      success: function(data) {
        if (
          data &&
          data.inactiveSessionTimeout &&
          data.inactiveSessionTimeout > 5
        ) {
          maxIdleTimeMiliSeconds = data.inactiveSessionTimeout * 60 * 1000;
        }
      },
      error: function(e) {
        window.location.href = "/";
      },
    });
    if ((window as any)._c == null) {
      (window as any)._c = JSON.parse(
        $.ajax({ type: "GET", url: "/Api/Utility/GetClientId", async: false })
          .responseText
      ).clientId;
    }

    if ((window as any)._c) {
      Cookie.set(clientIdCookie, (window as any)._c);
    }
  };

  useEffect(() => {
    loadConfigValues();
    checkClientIdCookie();
    checkClientTimeZone();
    if (
      !Cookie.get(cptCookieName) &&
      window.location.pathname != "/Admin/TermsOfUseUserAgreement" &&
      Object.keys(currentUser || {})?.length > 0 && !isExternalUser
    ) {
      Cookie.set(cptCookieName, 1, 365);
      securityWarningConfigs.toggleCptLicensingWarningWindow();
    }

    if (Cookie.get("lastActivityTimestamp") == null) {
      lastActivityTimestamp = new Date().getTime();
      Cookie.set("lastActivityTimestamp", lastActivityTimestamp);
    }
    const userMessagesRefreshTimeInSec = currentUser?.userMessagesRefreshTimeInSec || 300;
    if(Object.keys(currentUser || {})?.length > 0){      
      setInterval(function() {
        if (Cookie.get("isUiBulkOperationInProgress") == "true") {
          setLastActivityTime();
        }
        let currentTimestamp;
        // Refresh token
        if (Cookie.get("refreshTokenFailed") != "true") {
          currentTimestamp = new Date().getTime();
          let currentTokenElapsedTime =
            (currentTimestamp - parseInt(Cookie.get("tokenIssueTimestamp"))) /
            1000;
          const authProvider = Cookie.get("MDAUDIT_AUTH_PROVIDER");
        //if (authProvider !== "OKTA/OKTA")
          if(!authProvider.toLowerCase().startsWith("okta"))
            console.log(
              "Current token elapsed time :" +
                currentTokenElapsedTime +
                " seconds."
            );

          if (
            currentTokenElapsedTime >= refreshTokenInterval &&
            !authProvider.toLowerCase().startsWith("okta")
          ) {
            refreshTokenConfig.refreshToken();
          }
        }

        if (pingCooldown < pingCooldownMax) {
          pingCooldown++;
        }else if(pingCooldown === pingCooldownMax){
          pingServer();
        }

        /* IF USER IS NOT ACTIVE ON THIS TAB AND REFRESH TOKEN IS FAILED ON OTHER TAB THEN SHOW THE WARNING POPUP TO THE USER */
        if (
          Cookie.get("refreshTokenFailed") == "true" &&
          Cookie.get("isRefreshTokenFailedPopupClosedByUser") != "true" &&
          !isRefreshTokenFailureCountdownDialogOpen
        ) {
          refreshTokenConfig.openRefreshTokenFailureWarningWindow();
        }

        currentTimestamp = new Date().getTime();
        let inactiveTimeInMiliSeconds =
          currentTimestamp - parseInt(Cookie.get("lastActivityTimestamp"));
        let inactiveTimeThreshold =
          maxIdleTimeMiliSeconds - idleTimePopupMiliSeconds;

        if (inactiveTimeInMiliSeconds < maxIdleTimeMiliSeconds) {
          let inactiveTimeInSeconds = parseInt(
            inactiveTimeInMiliSeconds / 1000 + ""
          );
          console.log("Inactive time " + inactiveTimeInSeconds + " seconds.");
          if (
            inactiveTimeInSeconds >= inactiveTimeThreshold / 1000 &&
            Cookie.get("refreshTokenFailed") != "true" &&
            !isInactiveSessionWarningPopupOpen
          ) {
            /*
            * CHECK IDLE TIME POPUP IS OPEN OR NOT IF NOT THEN CHECK THE INACTIVE TIME
            * IF INACTIVE TIME IS GREATER THAN EQUAL TO INACTIVE TIME THRESHOLD AND REFRESH TOKEN IS NOT FAILED
            * THEN OPEN THE IDLE TIME POPUP
            */
            inactiveSessionConfig.openWarningWindow();
          } else if (
            isInactiveSessionWarningPopupOpen &&
            Cookie.get("isCountdownDialogOpen") == "false" &&
            inactiveTimeInSeconds < inactiveTimeThreshold / 1000
          ) {
            /* CLOSE THE IDLE TIME LOGOUT DIALOG IF USER IS ACTIVE ON ANOTHER TWO APPLICATIONS */
            inactiveSessionConfig.closeWarningWindow();
          }
        } else {
          sessionConfigs.logoutAll();
        }
      }, userMessagesRefreshTimeInSec / pingCooldownMax * 1000); //time in millisecond for each pingCooldown
    }

    setInterval(function() {
      if (
        Cookie.get("isCountdownDialogOpen") == "true" &&
        !isInactiveSessionWarningPopupOpen
      ) {
        inactiveSessionConfig.openWarningWindow();
      }
    }, 3000);

    refreshTokenConfig.setCountdownTimerForRefreshTokenFailedPopup();

    if (Cookie.get("isCountdownDialogOpen") == "true") {
      inactiveSessionConfig.openWarningWindow();
    }

    securityWarningConfigs.toggleSecurityWarningWindow();

    window.addEventListener("storage", windowEventHandlers.storageHandler);
    window.addEventListener("mouseup", windowEventHandlers.mouseUpHandler);
    window.addEventListener("keypress", windowEventHandlers.keyPressHandler);
    window.addEventListener("blur", windowEventHandlers.blurHandler);
    window.addEventListener("mousemove", windowEventHandlers.mouseMoveHandler);
    window.addEventListener("focus", windowEventHandlers.focusHandler);

    return () => {
      window.removeEventListener("mouseup", windowEventHandlers.mouseUpHandler);
      window.removeEventListener(
        "keypress",
        windowEventHandlers.keyPressHandler
      );
      window.removeEventListener("blur", windowEventHandlers.blurHandler);
      window.removeEventListener(
        "mousemove",
        windowEventHandlers.mouseMoveHandler
      );
      window.removeEventListener("focus", windowEventHandlers.focusHandler);
      window.removeEventListener("storage", windowEventHandlers.storageHandler);
    };
  });
  return (
    <div>
      <NotifyPopup
        id={"dialog-refreshtoken-failure-message"}
        actionType={TOGGLE_REFRESH_TOKEN_FAILED_POPUP}
        onShown={(e) => {
          $(e.component.content())
            .parents(".dx-overlay-content")
            .css("z-index", getHighestZIndex());
        }}
        widgetConfigPropertyName={"refreshTokenPopupConfig"}
        reducerName={"appReducer"}
      ></NotifyPopup>
      <NotifyPopup
        id={"securityNotice"}
        actionType={TOGGLE_SECURITY_NOTICE_POPUP}
        widgetConfigPropertyName={"securityNoticePopupConfig"}
        reducerName={"appReducer"}
      ></NotifyPopup>
      <NotifyPopup
        id={"pnlCPTLicensingWarning"}
        actionType={TOGGLE_CPT_LICENSING_POPUP}
        widgetConfigPropertyName={"cptLicensingPopupConfig"}
        reducerName={"appReducer"}
      ></NotifyPopup>
      <ConfirmationPopup
        id={"dialog-message"}
        onShown={(e) => {
          $(e.component.content())
            .parents(".dx-overlay-content")
            .css("z-index", getHighestZIndex());
        }}
        actionType={TOGGLE_INACTIVE_SESSION_WARNING_POPUP}
        widgetConfigPropertyName={"inactiveSessionWarningPopupConfig"}
        reducerName={"appReducer"}
      ></ConfirmationPopup>
    </div>
  );
};

export const logoutAll = sessionConfigs.logoutAll;
export default ApplicationEventHandler;
